





































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Inject } from "vue-property-decorator";
import { ModelState } from "@elite/validation";
import { RestClient } from "@elite/restclient";
import { IClonePromotionModel } from "../../models";
import { EditPromotionRoute } from "../../router";

@Component
export default class ClonePromotionModal extends Vue {
    @Inject()
    restClient!: RestClient;

    @Inject()
    modelState!: ModelState;

    @Prop({ required: true, type: Boolean })
    value!: boolean;

    @Prop({ required: true })
    model!: IClonePromotionModel;

    get localValue(): boolean {
        return this.value;
    }
    set localValue(value: boolean) {
        this.$emit("input", value);
    }

    async saveClicked(): Promise<void> {
        if (!this.model) {
            return;
        }

        const response = await this.restClient.postJson<IClonePromotionModel>(
            "/api/Promotion/Clone",
            this.model
        );

        if (this.modelState.hasErrors(response)) {
            this.modelState.addResponseErrors(response, this);
            return;
        }

        if (response.data && response.data.newPromotionId != null) {
            this.$router.push({
                name: EditPromotionRoute.name,
                params: { id: response.data.newPromotionId.toString() }
            });
        }

        this.localValue = false;
    }
}
